import { Typography } from "../Typography";
import { StyledChip } from "./styled";
import { IChipProps } from "./types";

const Chip = ({ label, color, variant = "filled", ...props }: IChipProps) => (
    <StyledChip
        {...props}
        customColor={color}
        customVariant={variant}
        label={
            <Typography variant="caption">
                {label}
            </Typography>
        }
    />
);

export { Chip };